'use client';

import '@ui5/webcomponents/dist/Select.js';
import { ValueState } from '../../enums/index.js';
import { withWebComponent } from '../../internal/withWebComponent.js';
/**
 * The `Select` component is used to create a drop-down list.
 *
 * __Note:__ This component is a web component developed by the UI5 Web Components’ team.
 *
 * [UI5 Web Components Storybook](https://sap.github.io/ui5-webcomponents/playground/?path=/docs/main-Select)
 */
const Select = withWebComponent('ui5-select', ['accessibleName', 'accessibleNameRef', 'menu', 'name', 'value', 'valueState'], ['disabled', 'readonly', 'required'], ['label', 'valueStateMessage'], ['change', 'close', 'live-change', 'open']);
Select.displayName = 'Select';
Select.defaultProps = {
  valueState: ValueState.None
};
export { Select };